// extracted by mini-css-extract-plugin
export var inputContainer = "_sj-0";